import { createMutation, createQuery } from '../../libs';
import { myBookingResponse, orderResponse, shareTicketResponse } from './models';

export const ordersUrl = 'orders';
const guestOrdersUrl = 'guest-users/orders';

export const useGetMyBooking = createQuery<myBookingResponse>(
  {
    method: 'get',
    url: `${ordersUrl}`,
  },
  {
    staleTime: 0,
    enabled: true,
  }
);

// This hook is not used anymore after braze notification trigger added
export const useNotificationGetOrder = createMutation<orderResponse, unknown>({
  method: 'get',
  url: `${ordersUrl}/:id`,
});

export const useRemindMe = createMutation<orderResponse, Partial<orderResponse>>({
  method: 'post',
  url: `${ordersUrl}/:id/:customUrl`,
});

export const useRemoveRemindMe = createMutation<orderResponse, Partial<orderResponse>>({
  method: 'delete',
  url: `${ordersUrl}/:id/:customUrl`,
});

export const useShareTicket = createMutation<shareTicketResponse>({
  method: 'post',
  url: `${ordersUrl}/:id/share-ticket`,
});

export const useGuestBookingShareTicket = createMutation<shareTicketResponse>({
  method: 'post',
  url: `${guestOrdersUrl}/:id/share-ticket`,
  transformRequest: (data, headers) => {
    headers['Content-Type'] = 'application/json';
    delete headers.Authorization;
    return JSON.stringify(data);
  },
});
